// extracted by mini-css-extract-plugin
export var header = "_u0-1";
export var maskBottom = "_u0-6";
export var maskMiddle = "_u0-7";
export var maskTop = "_u0-5";
export var root = "_u0-0";
export var scrollDownButton = "_u0-3";
export var scrollDownButtonHidden = "_u0-4";
export var viewport = "_u0-2";